/**
 * Vector QH 1/2000 layer: loads public/data/qhv/manifest.json and serves its tiles through the
 * 'qhv://{z}/{x}/{y}' protocol, which answers tiles known to be empty without a request (the
 * static host would otherwise return 404s, i.e. map errors). See core/vplan.js for the format.
 */
import { vurl } from './assetv.js';
import { parseVectorManifest, vectorTileHas } from './core/vplan.js';

const BASE = '/data/qhv/';
const EMPTY = () => ({ data: new ArrayBuffer(0) });
let man; // undefined: not loaded, null: unavailable (raster fallback), else the parsed manifest
let manP = null;
let registered = false;

/** Parsed manifest or null; resolves within `timeout` ms so the map never waits for long. */
export function loadVectorManifest({ timeout = 3500 } = {}) {
  if (man !== undefined) return Promise.resolve(man);
  manP ||= (async () => {
    const ac = new AbortController();
    const t = setTimeout(() => ac.abort(), timeout);
    try {
      const r = await fetch(vurl(BASE + 'manifest.json', 'qhv'), { signal: ac.signal });
      man = r.ok ? parseVectorManifest(await r.json()) : null;
    } catch { man = null; } finally { clearTimeout(t); }
    return man;
  })();
  return manP;
}

/** The manifest once loaded (null when the vector layer is unavailable). */
export const vectorManifest = () => man || null;

export function registerVectorProtocol(maplibregl) {
  if (registered) return;
  registered = true;
  maplibregl.addProtocol('qhv', async (params, ac) => {
    const m = /^qhv:\/\/(\d+)\/(\d+)\/(\d+)/.exec(params.url);
    if (!m || !man) return EMPTY();
    const z = +m[1], x = +m[2], y = +m[3];
    if (!vectorTileHas(man, z, x, y)) return EMPTY();
    const r = await fetch(`${BASE}${z}/${x}/${y}.pbf?v=${man.v}`, { signal: ac.signal });
    if (r.status === 404) return EMPTY();
    if (!r.ok) throw new Error('Lớp vector ' + r.status);
    return { data: await r.arrayBuffer() };
  });
}
